<tui-hosted-dropdown
    #dropdown
    class="t-select"
    [content]="menu"
>
    <button
        tuiButton
        appearance=""
        size="s"
        type="button"
        [iconRight]="arrow"
    >
        {{ currentMode }}
    </button>
    <ng-template #arrow>
        <tui-svg
            src="tuiIconChevronDown"
            class="t-arrow"
            [class.t-arrow_rotated]="dropdown.open"
        ></tui-svg>
    </ng-template>
    <ng-template #menu>
        <tui-data-list
            role="menu"
            size="s"
            class="t-menu"
        >
            <button
                *ngFor="let mode of modes"
                tuiOption
                role="menuitemradio"
                [attr.aria-checked]="isModeActive(mode)"
                (keydown.enter.prevent)="onModeSelect(mode, dropdown)"
                (keydown.space.prevent)="onModeSelect(mode, dropdown)"
                (click)="onModeSelect(mode, dropdown)"
            >
                {{ mode }}
                <tui-svg
                    *ngIf="isModeActive(mode)"
                    src="tuiIconCheck"
                    class="t-checkmark"
                ></tui-svg>
            </button>
        </tui-data-list>
    </ng-template>
</tui-hosted-dropdown>
<ng-container *ngIf="isGradient">
    <hr class="t-hr" />
    <div
        class="t-wrapper"
        [style.background]="gradient"
    >
        <tui-linear-multi-picker
            class="t-gradient"
            [value]="stopsKeys"
            (valueChange)="onStopsChange($event)"
            (indexChange)="onIndexChange($event)"
        ></tui-linear-multi-picker>
    </div>
    <div class="t-buttons">
        <!-- TODO: Change to `tuiHintDescribe` when figure tuiDriver order issue -->
        <button
            *ngFor="let button of buttons"
            tuiIconButton
            type="button"
            size="xs"
            appearance=""
            tuiHintDescribe
            class="t-direction"
            [class.t-direction_active]="isDirectionActive(button)"
            [icon]="getIcon(button)"
            [tuiHint]="button"
            (click)="onDirectionChange(button)"
        ></button>
    </div>
</ng-container>
<tui-color-picker
    [color]="currentColor"
    (colorChange)="onColorChange($event)"
></tui-color-picker>
<tui-color-edit
    *ngIf="!isGradient"
    tuiGroup
    class="t-edit"
    [color]="color"
    (colorChange)="onColorChange($event)"
></tui-color-edit>
<tui-palette
    *ngIf="palette.size"
    class="t-palette"
    [colors]="palette"
    (selectedColor)="onPalettePick($event)"
></tui-palette>
